import {Menu, MenuProps} from 'antd';
import styles from './MenuBar.module.scss';

type IMenuBarProps = MenuProps;

const MenuBar = ({...restProps}: IMenuBarProps) => {
  return <Menu {...restProps} className={styles.idpMenuBar} mode="inline" />;
};

export default MenuBar;
